module.exports = __webpack_public_path__ + "img/logoSlide2.10665aac.png";